import Timeline, { DateHeader, TimelineHeaders } from "react-calendar-timeline";
import 'react-calendar-timeline/dist/style.css';
import { useEffect, useRef, useState } from "react";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";
import '../../../../styles/ergonomics/timeline.scss';
import { Panel } from "../../../../components/panels/Panel";
import {
  buildPhases1s,
  convertPhasesToTimelineData,
} from "../../../../services/ergonomics/ergonomics-service";
import { Tooltip } from '@heroui/react';
import { ErgonomicsNeedZoom } from "../ErgonomicsNeedZoom";


export const ErgonomicsCardTimeline = () => {

  const { data, filters, hoveredTimestamp, viewModeLabel, zoomDateRange } = useErgonomicsContext();

  const containerRef = useRef(null);
  const [width, setWidth] = useState(800);
  const [height, setHeight] = useState(800);

  const filtersDisplayText = Object.fromEntries(filters.data.map(o => [o.name, o.display_text]));
  const phases = buildPhases1s(data, filtersDisplayText);
  const {groups, items} = convertPhasesToTimelineData(phases, filters.data.map((o) => o.display_text));

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [zoomDateRange]);

  const headerHeight = 40;
  const usableHeight = height - headerHeight;
  const lineHeight = Math.floor(usableHeight / groups.length);

  // Hover bar
  const start = zoomDateRange?.start;
  const end = zoomDateRange?.stop;
  const sidebarWidth = 150;
  const timelineWidth = width - sidebarWidth;
  const timestampLineLeft = hoveredTimestamp && end > start ? sidebarWidth + ((hoveredTimestamp - start) / (end - start)) * timelineWidth : -1;

  return (
    <Panel title="CHRONIQUE D'ACTIVITE" subTitle={viewModeLabel} noPadding={true}>
      {
        zoomDateRange === null ? <ErgonomicsNeedZoom/> :
        <div ref={containerRef} className="h-full relative overflow-hidden">
          <Timeline
            key={width + ',' + height}
            groups={groups}
            items={items}
            minTime={zoomDateRange.start}
            maxTime={zoomDateRange.stop}
            visibleTimeStart={zoomDateRange.start}
            visibleTimeEnd={zoomDateRange.stop}
            lineHeight={lineHeight}
            itemRenderer={({ item, itemContext, getItemProps, getResizeProps }) => {
              const isHovered = hoveredTimestamp >= item.start_time && hoveredTimestamp <= item.end_time;
              return (
                <div
                  {...getItemProps({
                    className: `timeline-item ${isHovered ? 'timeline-item-hovered' : ''}`,
                    style: {
                      background: item.color,
                    }
                  })}
                >
                  <Tooltip content={item.title} showArrow={true}>
                    {item.title}
                  </Tooltip>
                </div>
              );
            }}
          >
            <TimelineHeaders>
              <DateHeader unit="hour" labelFormat="HH:mm" height={headerHeight} />
            </TimelineHeaders>
          </Timeline>

          {/* Timestamp bar */}
          {hoveredTimestamp && timestampLineLeft >= 0 && timestampLineLeft <= width && (
            <div
              className="absolute top-0 bottom-0 w-[2px] bg-perception-blue z-20 pointer-events-none"
              style={{ left: `${timestampLineLeft}px` }}
            />
          )}
        </div>
      }
    </Panel>
  );
};
